import React, { useState } from "react";
import { Dashboard } from "../Admi/Dashboard";
import ZoneMaster from "../Admi/ZoneMaster";
import AdminSidebar from "../Admi/AdminSidebar";
import { AssociateMaster } from "../Admi/AssociateMaster";
import ProjectHeadMaster from "../Admi/ProjectHeadMaster";
import { ProjectMaster } from "../Admi/ProjectMaster";
import PropertyOwnerMaster from "../Admi/PropertyOwnerMaster";
import { Sliders } from "../Admi/Sliders";
import { PropertiesMenu } from "../Admi/PropertiesMenu";
import { Properties } from "../Admi/Properties";
import { InvestorLead } from '../Admi/InvestorLead'
import Greetings from '../Admi/Greetings'
import NotificationPage from "../Admi/NotificationPage";
import { Investor } from "../Admi/Investor";
import GeoLocationPermission from "../Admi/GeoLocationPermission";
import LayoutApprovals from "../Admi/LayoutApprovals";

const AdminLayout = () => {
    const [activePage, setActivePage] = useState("dashboard");

    const renderPage = () => {
        switch (activePage) {
            case "dashboard":
                return <Dashboard />;
            case "sliders":
                return <Sliders />;
            case "properties-menu":
                return <PropertiesMenu />;
            case "properties":
                return <Properties />;
            case "zone-creation":
                return <ZoneMaster />;
            case "associate-creation":
                return <AssociateMaster />;
            case "project-creation":
                return <ProjectMaster />;
            case "project-head-creation":
                return <ProjectHeadMaster />;
            case "property-owner-creation":
                return <PropertyOwnerMaster />;
            case "investor-leads":
                return <InvestorLead />;
                 case "greetings-creation":
                return <Greetings />;
            case "enabled-location":
                return <GeoLocationPermission />;
            case "notifications-creation":
                return <NotificationPage />;
  case "layoutApprovals":
                return <LayoutApprovals />;

            case "investor":
                return <Investor />;
            default:
                return <Dashboard />;
        }
    };

    return (
        <>
            <div style={{ display: "flex", minHeight: "100vh" }}>
                <AdminSidebar
                    activePage={activePage}
                    onPageChange={setActivePage}
                />
                <div style={{ flex: 1 }}>{renderPage()}</div>
            </div>
        </>
    );
};

export default AdminLayout;
